import { withGalleryGridMasonryProps } from 'viewModel/gallery/withGalleryGridMasonryProps';
import GalleryGridMasonry from 'components/Community/GalleryGridMasonry/GalleryGridMasonry';

export default withGalleryGridMasonryProps(GalleryGridMasonry);
